/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ComponentType, FC, PropsWithRef, PropsWithoutRef } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import {
	componentWithCondition,
	type GetRefAttributes,
} from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';

export const componentWithFG = <A extends {}, B extends {}>(
	gateName: string,
	ComponentTrue: ComponentType<A>,
	ComponentFalse: ComponentType<B>,
): FC<
	PropsWithoutRef<A> & PropsWithoutRef<B> & GetRefAttributes<PropsWithRef<A>, PropsWithRef<B>>
> =>
	// eslint-disable-next-line jira/ff/static-feature-flags
	componentWithCondition(() => fg(gateName), ComponentTrue, ComponentFalse);
